import React, { FC, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AnyObject, ObjectSchema } from "yup";
import {
  emailSchema,
  extraFields,
  nameSchema,
  phoneNumber,
} from "../../../../../../utils/validationSchema";
import Button from "../../../../../../components/button/Button";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/redux-hooks";
import { selectContestsState } from "../../../../../../store/slices/contests";
import Label from "../../../../../../components/label/Label";
import { addApplication } from "../../../../../../api/asyncThuncks/contestsCards";
import { CONTEST_APPLICATIONS_DEFAULT_FIELD_NAMES } from "../../../../../../common/enums";
import AplicationSubmit from "../../../../../../assets/icon/AplicationSubmit";

export const FormFields: FC = () => {
  const dispatch = useAppDispatch();
  const { contestByUrl } = useAppSelector(selectContestsState);
  const [schema, setSchema] = useState<ObjectSchema<{}, AnyObject, {}, "">>(
    yup.object().shape({})
  );
  const [aplicationSubmit, setaplicationSubmit] = useState<boolean>(false);

  useEffect(() => {
    if (contestByUrl.application) {
      const arr = [
        ...contestByUrl.application?.defaultFields,
        ...contestByUrl.application?.extraFields,
      ];
      const validationSchema = yup.object().shape(
        arr.reduce((schema, field) => {
          if (field.name === CONTEST_APPLICATIONS_DEFAULT_FIELD_NAMES.name) {
            return {
              ...schema,
              [field.id]: nameSchema,
            };
          }
          if (field.name === CONTEST_APPLICATIONS_DEFAULT_FIELD_NAMES.email) {
            return {
              ...schema,
              [field.id]: emailSchema,
            };
          }
          if (field.name === CONTEST_APPLICATIONS_DEFAULT_FIELD_NAMES.phone) {
            return {
              ...schema,
              [field.id]: phoneNumber,
            };
          } else {
            return {
              ...schema,
              [field.id]: extraFields,
            };
          }
        }, {})
      );
      setSchema(validationSchema);
    }
  }, [contestByUrl]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm<Record<string, string>>({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = (data: any) => {
    const defaultFields: { fieldId: string; value: any }[] = [];
    const extraFields: { fieldId: string; value: any }[] = [];

    const keyValue = Object.keys(data).map((item: string) => {
      const objectValue = { fieldId: item, value: data[item] };
      return objectValue;
    });

    keyValue.map((item) => {
      contestByUrl.application?.defaultFields.map((defaultField) => {
        if (defaultField.id === item.fieldId) {
          return defaultFields.push(item);
        }
        return defaultField;
      });
      contestByUrl.application?.extraFields.map((extraField) => {
        if (extraField.id === item.fieldId) {
          return extraFields.push(item);
        }
        return extraField;
      });
      return item;
    });

    if (contestByUrl.application) {
      dispatch(
        addApplication({
          id: contestByUrl.application.id,
          defaultFields: defaultFields,
          extraFields: extraFields,
        })
      );
    }
    setaplicationSubmit(true);
    reset();
  };

  return (
    <>
      {!aplicationSubmit ? (
        <form onSubmit={onSubmitHandler}>
          {contestByUrl.application?.defaultFields &&
            contestByUrl.application.defaultFields.map((item) => {
              return (
                <div className="pb-4 w-full">
                  <Label title={item.title} />
                  <Controller
                    {...register(item.id)}
                    name={item.id}
                    control={control}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <>
                        <input
                          required
                          id={item.id}
                          name={item.id}
                          value={value}
                          onChange={onChange}
                          className="box-border w-full px-1.5 py-3 mt-0.5 text-sm font-normal inline-block bottom-2 border-[1.5px] border-light_gray mb-1 rounded-md focus:border-2 focus:border-orange outline-none"
                          placeholder={item.description}
                        />
                        {errors[item.id]?.message && (
                          <span className="pl-3 text-red text-[12px]">
                            {errors[item.id]?.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              );
            })}

          {contestByUrl.application?.extraFields &&
            contestByUrl.application.extraFields.map((item) => {
              return (
                <div className="pb-4 w-full">
                  <Label title={item.title} />
                  <Controller
                    {...register(item.id)}
                    name={item.id}
                    control={control}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <>
                        <input
                          id={item.id}
                          name={item.id}
                          value={value}
                          onChange={onChange}
                          className="box-border w-full px-1.5 py-3 mt-0.5 text-sm font-normal inline-block bottom-2 border-[1.5px] border-light_gray mb-1 rounded-md focus:border-2 focus:border-orange outline-none"
                          placeholder={item.description}
                        />
                        {errors[item.id]?.message && (
                          <span className="pl-3 text-red text-[12px]">
                            {errors[item.id]?.message}
                          </span>
                        )}
                      </>
                    )}
                  />
                </div>
              );
            })}

          <Button
            title="Відправити"
            type="submit"
            className="bg-orange text-white mb-5"
            onClick={handleSubmit((data) => onSubmitHandler(data))}
          />
          <span className="text-sm opacity-70">
            Відправляючи заявку Ви даєти згоду на обробку персональних даних ТОВ
            Фоззі Груп
          </span>
        </form>
      ) : (
        <div className="flex flex-col justify-center items-center">
          <div className="max-w-[18.75rem] flex flex-col justify-center items-center">
            <div className="py-7">
              <AplicationSubmit />
            </div>
            <p className="text-base text-center">
              Заявка відправлена. Ви отримаєте відповідь як тільки заявка буде
              розглянута. <br /> <br /> Дякуємо за увагу!
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default FormFields;
